const lithiumData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133791/assets/data-reports/price-assessments/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_f9500acb-4717-4cd1-bad7-6ed70fa4d97c_xptrum.png',
  priceAssessmentsBrochureFile: {
    file_name: 'Benchmark-Lithium-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'lithiumPriceAssessmentsMethodologyId',
  },
  forecastBrochureFile: {
    file_name: 'Lithium Forecast Brochure.pdf',
    category: 'public-documents',
    EnvKey: 'forecastBrochureLithiumFilePdfID',
  },
  esgBrochureFile: {
    file_name: 'Lithium Sustainability Brochure.pdf',
    category: 'lithium-esg-brochure',
    EnvKey: 'ESGBrochureLithiumFilePdfId',
  },
  banner: {
    title:
      'Our service includes a deep-dive on each link in the lithium supply chain including:',
    descriptions: [
      {
        items: [
          '<strong>Mine by Mine:</strong> Brine and Spodumene Analysis',
          '<strong>Plant by Plant:</strong> Lithium Carbonate & Hydroxide Analysis',
          '<strong>Battery Focus:</strong> Demand by Cathode Chemistry with market share & intensity numbers',
          '<strong>Battery Demand:</strong> Scenarios of EV, Stationary and Portable Tech',
          '<strong>Industrial vs Battery:</strong> Ceramics & Glass, Lubricants & Grease, Metallurgy, Air Treatment, Medical',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1718225642/assets/market/Lithium/overview/Benchmark_Minerals_lithium_mine_1_gwjirl.png?_i=AA',
        alt: 'Lithium Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1718225666/assets/market/Lithium/overview/Benchmark_Minerals_Charts_1_gc4ykp.png?_i=AA',
        alt: 'Lithium Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1718225684/assets/market/Lithium/overview/Benchmark_Minerals_Portable_tech_1_g2fiar.png?_i=AA',
        alt: 'Lithium Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,h_600,c_fill/v1718225709/assets/market/Lithium/overview/Benchmark_Minerals_shades_of_yellow_and_white__jzye5a.png?_i=AA',
      title:
        'Our full picture understanding of lithium is most prevalent in our bottom-up cost curve analysis.',
      descriptions: [
        {
          subtitle:
            'We present a "Total Cost" number for each operating mine and development project under review which also considers: Cash/Opex, Capital Charge & Taxes & Royalties.',
          items: [
            '<strong>Time Travel:</strong> Compare Cost Curves between 2019, 2020 & 2030',
            '<strong>Brine & Hard Rock:</strong> Understand the shifting relationship',
            '<strong>Plan for your future</strong> contracts, inventory or investment needs',
          ],
        },
        {
          subtitle:
            'Backed by our industry leading and IOSCO-regulated Lithium Price Assessment Data, our research team understand lithium’s nuances that will have a major impact on accurately forecasting prices.',
          items: [
            'Forecasted to 2040: <strong>Lithium Carbonate</strong>, Battery Grade Price, Global Prevailing Price',
            'Forecasted to 2040: <strong>Lithium Hydroxide</strong>, Battery Grade Price, Global Prevailing Price',
            'Forecasted to 2040: <strong>Spodumene </strong>6%, Australia FOB, Battery Market Material',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,h_600,c_fill/v1718225728/assets/market/Lithium/overview/Benchmark_Minerals_Futuristic_1_vx2mgy.png?_i=AA',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark’s Lithium Forecast service:',
      descriptions: [
        {
          items: [
            '<strong>Online accessible</strong> downloads each quarter',
            '<strong>Clear & Concise:</strong> our data is presented in 3 Excel Files - Lithium Forecast, Lithium Price Forecast & Lithium Total Cost Model',
            '<strong>Implement Your Ideas:</strong> Each file is fully customisable so you can input your own assumptions',
          ],
        },
      ],
    },
  },
}
export default lithiumData
